import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {gsap} from "gsap";
import {BruteForce} from "../BruteForce";
import {BruteForceGameConfig} from "../BruteForceGameConfig";
import {BruteForceSound} from "../sound/BruteForceSound";

export class BruteForceInitialWinPresentation implements SimplePresentation {
    name: string = "InitialWinPresentation";
    private _tl: gsap.core.Timeline;

    shouldRun(): boolean {
        return BruteForce.model.gameData.betLineWins.length > 0;
    }

    start(controller: SimplePresentationRunnerController): void {
        this._tl = gsap.timeline({
            onComplete: () => {
                controller.setSkipCallback();
                controller.finish();
            }
        });
        this._tl.add(() => {
            controller.setSkipCallback(() => this.onSkip());
            BruteForce.foregroundElements.playArcadeMachineAnimation("win", false)
        }, 0);
        this._tl.add(BruteForce.individualWinView.showLines());
        this._tl.add(() => {
            BruteForceGameConfig.initialWinPresentationSkip = false;
            BruteForceSound.betlineEffectsReset();
        })
    }

    private onSkip(): void {
        BruteForceGameConfig.initialWinPresentationSkip = true;
        BruteForceSound.stopBetlineHighlights();
        BruteForceSound.stopBetlineHighlightsOverlayM();
        this._tl.totalProgress(1);
    }
}